/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Task_Status_OverdueInputs */

const en_attribute_task_status_overdue = /** @type {(inputs: Attribute_Task_Status_OverdueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overdue`)
};

/**
* | output |
* | --- |
* | "Overdue" |
*
* @param {Attribute_Task_Status_OverdueInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_task_status_overdue = /** @type {((inputs?: Attribute_Task_Status_OverdueInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Task_Status_OverdueInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_task_status_overdue(inputs)
});